export const contractnumberQueryParam = 'contractnumber';
export const emailQueryParam = 'email';
export const phoneQueryParam = 'phonenumber';
export const originQueryParam = 'aiz';
export const originQueryEssentialParam = 'essential';
export const tabQueryParam = 'tab';

